import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DxButtonComponent, DxPopupComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { SaleItem } from '../../model/SaleItem';
import { VoucherDetails } from '../../model/voucher-details.model';
import { VoucherInputComponent } from '../voucher-input/voucher-input.component';

@Component({
  selector: 'app-voucher-tender',
  templateUrl: './voucher-tender.component.html',
  styleUrls: ['./voucher-tender.component.css']
})
export class VoucherTenderComponent {

  @Output() CloseDlg: EventEmitter<{ action: string, saleItem: SaleItem, voucher: VoucherDetails }> = new EventEmitter<{ action: string, saleItem: SaleItem, voucher: VoucherDetails }>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;

  item: SaleItem = null;
  saleItems: SaleItem[] = [];
  outstandingBalance: number = 0.0;
  details: VoucherDetails = null;
  message: string = "";

  @ViewChild(VoucherInputComponent) voucherInput: VoucherInputComponent;

  OkButtonOptions = {
    name: 'btnOKVoucher',
    text: 'Use Voucher',
    disabled: true,
    onClick: this.btnOK_Click.bind(this),
    onInitialized: this.btnOKInit.bind(this),
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this)
  };

  constructor() { }

  btnOK: any = null;
  btnOKInit(e) {
    this.btnOK = e.component;
    this.btnOK.option("disabled", true);
  }

  VoucherChanged(voucherDetails: VoucherDetails) {
    this.details = voucherDetails;
    if (this.details == null) {
      this.message = "No voucher was found with the specified voucher code";
      this.btnOK.option("disabled", true);
    }
    else {
      var v = this.saleItems.find(i => i.VoucherCode == this.details.VoucherCode);
      if (v) {
        this.message = "This voucher is already being tendered";
        this.btnOK.option('disabled', true);
        this.details=null;
      }
      else {
        this.message = "";
        if (this.details.Expired == false && this.details.RemainingBalance > 0)
          this.btnOK.option("disabled", false);
        else
          this.btnOK.option("disabled", true);
      }
    }
  }

  public show(outstandingBalance: number, saleItem: SaleItem, saleItems: SaleItem[]) {
    this.outstandingBalance = outstandingBalance;
    this.details = null;
    this.item = saleItem;
    this.saleItems = saleItems;
    this.popup.visible = true;
  }

  btnOK_Click(e) {
    this.CloseDialog("USEVOUCHER");
  }

  btnCancel(e) {
    this.CloseDialog("CANCEL");
  }

  CloseDialog(action: string) {
    this.CloseDlg.emit({ action: action, saleItem: this.item, voucher: this.details });
    this.voucherInput?.reset();
    this.popup.visible = false;
  }
}
